<template>
    <div>
        <breadcrumbs />
        <v-container>
            <v-card variant="outlined">
                <v-card-title v-text="$t(`page_title.${$route.name}`)" />
                <v-card-text>
                    <registration-form @registered="onRegistered" />
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import RegistrationForm from '~src/components/account/forms/registrationForm.src'

    @Component({
        components: {
            Breadcrumbs,
            RegistrationForm,
        },
    })
    export class RegistrationPage extends Vue {
        async mounted() {
            await this.$store.restored
            authStore.SET_REGISTERED_PERSON_PROP({prop: 'memberLevel', val: 'REGISTERED'})
        }

        async onRegistered() {
            await this.$router.push({name: 'home'})
            this.$toast.success(this.$t('registration_successful'))
        }
    }

    export default RegistrationPage
</script>
